<ng-container *ngComponentOutlet="getContainer(); inputs: formInputs" />
